<template>
  <v-container class="pt-6">
    <v-card class="elevation-12 mb-6">
      <v-card-title class="px-9 pt-7">
        Přehled požadavků
        <v-btn
          v-show="false"
          @click="loadAllRequests"
          icon
          class="ml-2"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <RequestsFilters @filter="setFiltersAction" :dealersFilter="true" />

        <TableRequests
          v-model="request"
          @openNoteDialog="openNoteDialog($event)"
          @onChangeOptions="loadAllRequests"
        />
      </v-card-text>
    </v-card>

    <MessageDialog v-model="dialog" />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import RequestsFilters from '@/components/RequestsFilters.vue';
import TableRequests from '@/components/tables/TableRequests.vue';
import MessageDialog from '@/components/dialogs/MessageDialog.vue';
import { setFilters } from '@/components/mixins/setFilters';

export default {
  name: 'RequestsAll',
  mixins: [setFilters],
  components: {
    RequestsFilters,
    TableRequests,
    MessageDialog,
  },
  data() {
    return {
      dialog: {
        content: '',
        show: false,
        data: {},
      },
      request: {
        selected: [],
        items: [],
        requestFooter: {
          selectedData: {
            params: {},
            items: [],
          },
        },
        options: {
          page: 1,
          itemsPerPage: this.$store.state.settings.tables.requests.itemsPerPage,
          sortBy: ['id'],
          sortDesc: [true],
        },
        loading: false,
        serverItemsLength: 0,
      },
      cancel: null,
      interval: null,
    };
  },
  methods: {
    ...mapActions({
      searchRequests: 'requests/searchRequests',
    }),
    openNoteDialog(data) {
      this.dialog.show = true;
      this.dialog.title = `Komentář k požadavku č. ${data.id}`;
      this.dialog.data = data;
      this.dialog.content = data.lastActivityNote;
    },
    loadAllRequests() {
      this.request.loading = true;
      const searchParams = {
        filterParams: {
          ...this.$route.query,
          onlyMyRequests: false,
        },
        options: this.request.options,
      };
      if (this.cancel) {
        this.cancel();
        this.cancel = null;
      }
      searchParams.cancelHandler = (cancel) => {
        this.cancel = cancel;
      };
      this.request.requestFooter.selectedData.params = searchParams;
      this.searchRequests(searchParams).then((response) => {
        this.request.requestFooter.totalElements = response.data.totalElements;
        this.request.items = response.data.items;
        this.request.serverItemsLength = response.data.totalElements;
        this.$store.commit('settings/FILTER_UPDATE', {
          key: 'requests',
          value: this.$route.query,
        });
        this.cancel = null;
      }).finally(() => {
        this.request.loading = false;
      });
    },
    setFiltersAction(filters) {
      this.request.options.page = 1;
      this.setFilters(filters);
    },
    loadAllRequestsInterval() {
      this.interval = setInterval(() => {
        this.loadAllRequests();
      }, 900000);
    },
  },
  watch: {
    'request.selected': {
      handler() {
        this.request.requestFooter.selectedData.items = this.request.selected;
      },
    },
    '$route.query': {
      handler() {
        this.loadAllRequests();
      },
    },
  },
  created() {
    this.loadAllRequestsInterval();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>
